export default __webpack_public_path__ + "static/media/00.e1c864ad.jpg";